// @ts-nocheck
export const localeCodes =  [
  "nl",
  "en",
  "de"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46ts_d4d1a6d7",
      load: () => import("#nuxt-i18n/d4d1a6d7" /* webpackChunkName: "locale_nl_46ts_d4d1a6d7" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46ts_ed48fe66",
      load: () => import("#nuxt-i18n/ed48fe66" /* webpackChunkName: "locale_en_46ts_ed48fe66" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46ts_5e342c21",
      load: () => import("#nuxt-i18n/5e342c21" /* webpackChunkName: "locale_de_46ts_5e342c21" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/887749ea" /* webpackChunkName: "config_vue_45i18n_46ts_887749ea" */)
]
export const normalizedLocales = [
  {
    code: "nl",
    language: undefined
  },
  {
    code: "en",
    language: undefined
  },
  {
    code: "de",
    language: undefined
  }
]
/** client **/

/** client-end **/